import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import metaData from '../data/metaData.json';

export const usePageMeta = (customMeta = {}) => {
  const location = useLocation();
  const path = location.pathname;
  
  useEffect(() => {
    // Get page-specific meta or fall back to default
    const pageMeta = metaData.pages?.[path] || metaData.default || {};
    
    // Allow custom meta to override
    const mergedMeta = { ...pageMeta, ...customMeta };
    
    // Ensure we have valid strings with explicit fallbacks
    const title = String(mergedMeta.title || metaData.default?.title || 'Digital Startup');
    const description = String(mergedMeta.description || metaData.default?.description || '');
    const keywords = String(mergedMeta.keywords || metaData.default?.keywords || '');
    
    // Update document title
    document.title = title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    }
    
    // Update og:title
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', title);
    } else {
      const newOgTitle = document.createElement('meta');
      newOgTitle.setAttribute('property', 'og:title');
      newOgTitle.setAttribute('content', title);
      document.head.appendChild(newOgTitle);
    }
    
    // Update og:description
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) {
      ogDesc.setAttribute('content', description);
    } else {
      const newOgDesc = document.createElement('meta');
      newOgDesc.setAttribute('property', 'og:description');
      newOgDesc.setAttribute('content', description);
      document.head.appendChild(newOgDesc);
    }
    
  }, [path, customMeta]);
};

export default usePageMeta;
